import { Controller } from "@hotwired/stimulus"

// Carga lazy el `src` de un turbo-frame existente al montar.
//
// Uso:
//   <div data-controller="manage--frame-loader"
//        data-manage--frame-loader-frame-id-value="modal"
//        data-manage--frame-loader-url-value="/edit/url"></div>
//
// Casos de uso: abrir un modal automaticamente al volver de un redirect server-side.

export default class extends Controller {
  static values = {
    frameId: String,
    url: String,
  }

  connect() {
    const frame = document.getElementById(this.frameIdValue)
    if (frame && this.urlValue) {
      frame.src = this.urlValue
    }
  }
}
